<template>
  <div class="modal proposal-analytics-modal animated fadeIn" :class="{ 'is-active': $route.path.indexOf('/analytics') > -1 }">
    <div class="modal-background"></div>

    <span class="close-modal" @click="$router.push('/a/documents')">
      <i class="icon icon-close"></i>
    </span>

    <div class="modal-card animated fadeInUp">
      <loading-indicator v-if="documentLoaded === false"></loading-indicator>

      <div class="analytics-header" v-if="documentLoaded">
        <h2>{{ $t('document_analytics_modal.document_analytics') }}</h2>
        <h1>{{ document.title }}</h1>
        <p class="prepared-deets">
          <span><strong>{{ $t('document_analytics_modal.prepared_for') }}:</strong> {{ document.cover.createdBy }}</span>
          <span><strong>{{ $t('document_analytics_modal.prepared_by') }}:</strong> {{ document.cover.createdFor }}</span>
        </p>
      </div>

      <div class="analytics-main-wrapper">
        <div class="analytics-left-wrapper">
          <div class="analytics-toggle">
            <span :class="{ 'active' : !tab || tab === 'recipients' }" @click="tab = 'recipients'">{{ $t('document_analytics_modal.recipients') }}</span>
            <span :class="{ 'active' : tab === 'timeline' }" @click="tab = 'timeline'">{{ $t('document_analytics_modal.timeline') }}</span>
          </div>
          <div class="analytics-left" v-if="tab === 'timeline'">
            <h4>{{ $t('document_analytics_modal.activity') }}</h4>
            <ul v-if="analytics.timeline.length > 0" v-for="event in analytics.timeline">
              <li>
                <span class="download"><i class="icon" :class="mapClass(event.action)"></i></span>
                <span v-html="$t('document_analytics_modal.event', { viewer: event.viewer.name, action: event.action, time:  event.created_at | time, date: event.created_at | date })"></span>

              </li>
            </ul>
            <p v-else>{{ $t('document_analytics_modal.default_message') }}</p>
          </div>
          <div class="analytics-left" v-if="tab === 'recipients'">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ $t('document_analytics_modal.recipient') }}</th>
                  <th>{{ $t('document_analytics_modal.times_viewed') }}</th>
                  <th>{{ $t('document_analytics_modal.total_time_spent') }}</th>
                  <th>{{ $t('document_analytics_modal.last_viewed') }}</th>
                  <th>{{ $t('document_analytics_modal.downloaded') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(person, index) in analytics.summary">
                  <td>{{ index }}</td>
                  <td>{{ person.times }}</td>
                  <td>{{ person.time }}</td>
                  <td>{{ person.last }}</td>
                  <td>{{ person.download }}</td>
                  <td></td>
                  <!--<td>-->
                    <!--<div class="analytics-options">-->
                      <!--<a><i class="icon icon-send"></i></a>-->
                      <!--<a><i class="icon icon-view"></i></a>-->
                    <!--</div>-->
                  <!--</td>-->
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="analytics-comments-wrapper">
          <h3>{{ $t('document_analytics_modal.comments') }}</h3>
          <div class="analytics-comments">
            <section class="analytics-comments-body">
              <ul v-if="comments !== false && comments.length > 0">
                <comment :comment="comment" :show-avatar="true" comment-type="full" v-for="comment in comments" :key="comment.id"></comment>
              </ul>
            </section>
            <footer class="analytics-comments-foot">
              <textarea v-model="newCommentBody" @keydown.enter.stop="submitComment" :disabled="disableNewComments" :placeholder="$t('document_analytics_modal.comment_text_placeholder')"></textarea>
              <a class="button is-primary is-medium is-pulled-left push-right" @click="submitComment">{{ $t('document_analytics_modal.send_message') }}</a>
              <a class="button is-primary is-medium is-outlined is-pulled-left">{{ $t('document_analytics_modal.cancel') }}</a>
            </footer>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import API from 'mixins/api';
  import Comment from 'components/partials/comment.vue';

  export default {
    mixins: [API],
    components: {
      Comment,
    },
    data() {
      return {
        Events: window.Events,
        tab: 'recipients',
        analytics: [],
        comments: [],
        document: {
          id: null,
          cover: {},
          document: []
        },
        documentLoaded: false,
        saveTimer: 0,
        newCommentBody: '',
        disableNewComments: false
      }
    },
    beforeMount() {
      this.api().fetchDocument(this.$route.params.id)
        .then(document => {
          this.document = document;
          this.comments = document.comments;
          this.documentLoaded = true;
        });

      this.api().fetchDocumentAnalytics(this.$route.params.id)
        .then(analytics => {
          this.analytics = analytics;
        });

      this.api().fetchDocumentComments(this.$route.params.id)
        .then(comments => {
          this.comments = comments;
        });
    },
    methods: {
      goBack() {
        window.history.back();
      },
      submitComment() {
        this.disableNewComments = true;
        return this.api().createComment(this.$route.params.id, { body: this.newCommentBody })
        .then(response => {
          // check for success
          this.disableNewComments = false;
          this.newCommentBody = '';
          (new Notyf()).confirm(this.$t('document_analytics_modal.comment_sent'));
          this.api().fetchDocumentComments(this.$route.params.id)
            .then(comments => {
              this.comments = comments;
            });
        },
        response => {
          this.disableNewComments = false;
          (new Notyf()).alert(this.$t('document_analytics_modal.comment_failed'));
        });
      },
      mapClass(action) {
        let classes = {
          "viewed": "icon-view",
          "commented": "icon-chat",
          "signed": "icon-signature",
          "downloaded": "icon-download"
        };
        return classes[action];
      }
    },
    filters: {
      time: function (timeStamp) {
        return moment(timeStamp).format('h:mm a');
      },
      date: function (timeStamp) {
        return moment(timeStamp).format('M/YY');
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .fadeIn {
    animation-duration: 500ms;
  }

  .fadeInUp {
    animation-duration: 500ms;
  }

  .modal-background {
    background: darken($eggshell, 2%);
    position: fixed;
  }

  .close-modal {
    i {
      font-size: 30px;
      right: 30px;
      top: 15px;
      position: absolute;
      &:hover {
       color: $green;
       cursor: pointer;
      }
    }
  }


  .modal {
    flex-direction: column;
    .modal-card {
      border: none;
      box-shadow: none;
      background: none;
      width: 100%;
      margin: 0;
      padding: 0;
      top: 0;
      position: absolute;
      overflow: visible;
      .analytics-header {
        width: 100%;
        max-width: 1400px;
        margin-left: auto;
        margin-right: auto;
        z-index: 10;
        padding: 30px 40px;
        h1 {
          font-size: 36px;
          color: $purple;
          margin: 7px 0;
          font-weight: 900;
          line-height: 38px;
        }
        h2 {
          color: $mutedblue;
          margin: 0;
        }
        p {
          color: $grey;
          &.client {
            margin-bottom: 5px;
            font-size: 18px;
          }
          span {
            margin-right: 20px;
            strong {
              color: $grey;
            }
          }
        }
      }
      .analytics-main-wrapper {
        display: flex;
        flex-direction: row;
        width: 100%;
        max-width: 1400px;
        margin-left: auto;
        margin-right: auto;
        padding: 0 40px;
        .analytics-left-wrapper {
          flex-grow: 2;
          max-width: 880px;
          .analytics-toggle {
            display: flex;
            align-items: center;
            text-transform: uppercase;
            letter-spacing: 1px;
            font-family: Proxima Nova;
            span {
              font-size: 12px;
              text-transform: uppercase;
              font-weight: 600;
              margin: 0 0 20px;
              letter-spacing: 1px;
              margin: 0px 5px 0 0;
              text-align: center;
              padding: 10px 15px;
              cursor: pointer;
              background: $white;
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;
              box-shadow: 0 -6px 18px -2px rgba(211,215,221,0.50), inset 0 -6px 4px 0 rgba(0,0,0,0.03);
              color: $mutedblue;
              &.active {
                color: $purple;
                box-shadow: 0 -6px 18px -2px rgba(211,215,221,0.50), inset 0 -6px 4px 0 rgba(0,0,0,0);
              }
            }
          }
          .analytics-left {
            min-height: calc(100vh - 250px);
            border: 1px solid $white;
            background: $white;
            box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
            padding: 20px;
            border-radius: 5px;
            border-top-left-radius: 0;
            h4 {
              font-size: 14px;
              text-transform: uppercase;
              font-weight: 600;
              margin: 0;
              padding: 0.5em 0.75em;
              letter-spacing: 1px;
            }
            ul {
              li {
                padding: 0.5em 0.75em;
                span.download {
                  width: 30px;
                  height: 30px;
                  background: $purple;
                  display: inline-block;
                  border-radius: 50px;
                  margin-right: 15px;
                  text-align: center;
                  padding-top: 5px;
                  padding-left: 2px;
                  i {
                    color: $white;
                    font-size: 18px;
                  }
                  &.view,
                  &.comment {
                    padding-top: 6px;
                    padding-left: 1px;
                  }
                }
              }
            }
            table {
              border-bottom: 1px solid lighten($mutedblue, 15%);
              thead {
                tr {
                  th {
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    color: $grey;
                    font-size: 12px;
                    font-weight: 600;
                    border-width: 0 0 1px;
                  }
                  &:hover {
                    background-color: $white;
                  }
                }
              }
              tbody {
                tr {
                  td {
                    vertical-align: inherit;
                    .analytics-options {
                      text-align: right;
                      font-size: 18px;
                      padding-top: 4px;
                      opacity: 0;
                      -webkit-transition: all .3s ease;
                      -moz-transition: all .3s ease;
                      -ms-transition: all .3s ease;
                      -o-transition: all .3s ease;
                      transition: all .3s ease;
                      a {
                        color: $mutedblue;
                        margin-left: 10px;
                        i {
                          &:hover {
                            color: $green;
                            cursor: pointer;
                          }
                        }
                        &.edit {
                          i {
                            margin-top: 1px;
                          }
                        }
                      }
                    }
                  }
                  &:hover {
                    background-color: $eggshell;
                    td {
                      .analytics-options {
                        opacity: 1;
                      }
                    }
                  }
                }
              }
            }
            .table td, .table th {
              border: 1px solid lighten($mutedblue, 15%);
              border-width: 0 0 1px;
            }
          }
        }
        .analytics-comments-wrapper {
          flex-grow: 1;
          margin-left: 40px;
          max-width: 400px;
          h3 {
            font-size: 14px;
            text-transform: uppercase;
            font-weight: 600;
            margin: 0 0 20px;
            letter-spacing: 1px;
          }
          .analytics-comments {
            display: flex;
            height: calc(100vh - 250px);
            max-height: calc(200vh);
            overflow-y: auto;
            flex-direction: column;
            border: 1px solid $white;
            background: $white;
            box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
            border-radius: 5px;
            &-body {
              padding: 24px;
              flex-grow: 1;
              flex-shrink: 1;
              overflow: auto;
              ul {
                list-style-type: none;
                margin: 0;
                padding: 0;
              }
            }
            &-foot {
              border-top: 1px solid lighten($mutedblue, 12%);
              padding: 24px 24px;
              text-align: center;
              display: block;
              align-items: center;
              flex-shrink: 0;
              justify-content: flex-start;
              position: relative;
              .button {
                opacity: 0;
                margin-top: -50px;
                -webkit-transition: opacity 0.2s, margin-top .3s .1s;
                -moz-transition: opacity 0.2s, margin-top .3s .1s;
                transition: opacity 0.2s, margin-top .3s .1s;
                pointer-events: none;
              }
              textarea {
                height: 43px;
                -webkit-transition: all 0.3s .1s;
                -moz-transition: all 0.3s .1s;
                transition: all 0.3s .1s;
                &:focus {
                  margin-bottom: 15px;
                  height: 100px;
                  -webkit-transition: all 0.3s;
                  -moz-transition: all 0.3s;
                  transition: all 0.3s;
                  ~ .button {
                    margin-top: 0;
                    opacity: 1;
                    pointer-events: auto;
                    -webkit-transition: all 0.3s .1s;
                    -moz-transition: all 0.3s .1s;
                    transition: all 0.3s .1s;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// document-analytics-modal.vue?1911c460